import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { SmartForm, SmartInput, Button, Link, Preloader } from 'components';

import BeautyCtn from '../BeautyCtn';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

class SMSForm extends React.Component {
  validateCode = (value) => ({
    status: value && value.length === 5 && !/^([0-9])\1+$/.test(value) ? 'ok' : 'typo',
  });

  renderHiddenFields = () => {
    const { loginModel } = this.props;
    if (loginModel) {
      return (
        <div className={cx('hiddenFields')}>
          {Object.keys(loginModel).map((value, index) => (
            <input type="hidden" key={+index} name={value} value={loginModel[value]} />
          ))}
        </div>
      );
    }

    return null;
  };

  render() {
    const {
      isCompact,
      isLight,
      isPending,
      description,
      ctn,
      bisUrl,
      buttonText,
      position,
      onReset,
      onSMSRequest,
    } = this.props;

    return (
      <SmartForm
        className={cx('form', { compact: isCompact, light: isLight })}
        validator={{ code: this.validateCode }}
        autoComplete="off"
        method="POST"
        action={`${bisUrl}/identity/fpcc`}
      >
        <BeautyCtn ctn={ctn} onReset={onReset} className={cx('marb-xs')} />
        <div className={cx('marb-xs')}>
          {description}
          <Link onClick={onSMSRequest} className={cx('link')}>
            Отправить повторно
          </Link>
        </div>
        <SmartInput
          className={cx('inputField', position)}
          placeholder="Пароль из SMS"
          name="password"
          inputId="password"
          size="default"
          mask="_____"
          disabled={isPending}
        />
        {this.renderHiddenFields()}
        {isPending ?
          <div className={cx('loader')}>
            <Preloader />
          </div>
        : <Button className={cx('button')}>{buttonText}</Button>}
      </SmartForm>
    );
  }
}

SMSForm.propTypes = {
  isLight: PropTypes.bool,
  isCompact: PropTypes.bool,
  bisUrl: PropTypes.string,
  ctn: PropTypes.string,
  isPending: PropTypes.bool,
  position: PropTypes.string,
  buttonText: PropTypes.string,
  description: PropTypes.string,
  loginModel: PropTypes.object,
  onReset: PropTypes.func,
  onSMSRequest: PropTypes.func,
};

export default SMSForm;
